import React, { Component } from 'react';
import { Icon,Input } from 'antd';

class ContentList extends Component {
    state = {
        errChoose: undefined,
        notExistJdeCodes:[],
        duplicateJdeCodes:[]
    }

    jugeTolast=(id)=>{
        const element = document.getElementById(id);
        if(element){
            element.scrollIntoView(false);
        }
        if(id!="mulInput"){
            this.setErrRemark(id)
        }
       
    }

    setErrRemark=(id)=>{//设置错误的那一条id
        this.setState({ 
            errChoose:id 
         })
    }

    setRemindList=(notExistJdeCodes,duplicateJdeCodes)=>{
        this.setState({ 
            notExistJdeCodes,
            duplicateJdeCodes
         }) 
    }

    render() {
        const { data=[], render, onRemove, className = '', circle = false, } = this.props;

        //const{errChoose}=this.state;

        //const deteable = data.length>1;
        const deteable = true;

        const{notExistJdeCodes=[],duplicateJdeCodes=[]}=this.state;

        return (
            <div className={`content-list ${className}`} style={{marginTop:"0px"}}>
                {
                    (data || []).map((item, index) => {
                        const text = render(item);
                        const showNotExist = notExistJdeCodes&&notExistJdeCodes.includes(item);//不存在
                        const showDuplicate = duplicateJdeCodes&&duplicateJdeCodes.includes(item);//重复
                        return (
                            <div className="content-item" key={index} style={{marginBottom:"10px"}} id={(data.length==index+1)?"mulInput":null}>
                                <div className="item-text" title={text} id={`${index}choose`}>
                                    <Input maxLength="1000" value={text} placeholder={"请输入"} style={{ width: 240 }} disabled={true} onChange={(e)=>onChange(e,index)}/>
                                    { deteable && <Icon type={!circle ? "close-circle" : "close-circle-o" } 
                                    style={{fontSize:"20px",color:"red",marginLeft:"10px",position:"relative",top:"3px"}}
                                    onClick={() => onRemove(index)}/> }
                                    {showDuplicate&&<span className="errRemark" title="JDE项目号重复">JDE项目号重复</span>}
                                    {showNotExist&&<span className="errRemark" title="JDE项目号不存在">JDE项目号不存在</span>}                                
                                </div>
                                {/* <div className="item-icon">
                                    { deteable && <Icon type={!circle ? "close-circle" : "close-circle-o" } onClick={() => onRemove(index)}/> }
                                </div> */}
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

export default ContentList;


// WEBPACK FOOTER //
// ./src/components/layout/ContentList.js